module.exports = "https://cdn.hellotech.com/client-assets/security_cameras_mobile_54cf60060d8bbbef4f0fc2862619ba62.png";